import { render, staticRenderFns } from "./CreateLetter.vue?vue&type=template&id=01bc96de&scoped=true&"
import script from "./CreateLetter.vue?vue&type=script&lang=js&"
export * from "./CreateLetter.vue?vue&type=script&lang=js&"
import style0 from "./CreateLetter.vue?vue&type=style&index=0&id=01bc96de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bc96de",
  null
  
)

export default component.exports